/**
 * Los productos del mapa facial de la clínica (2026-09-28): qué se marca en
 * la cara y con qué color. Los edita gestión; se guardan en la base
 * (PUT /api/mapa-facial/productos). El primero es el marcador por defecto.
 * Quitar uno no toca los puntos que ya lo llevan: se siguen viendo, en gris.
 */
import React, { useState } from 'react';
import { toast } from 'sonner';
import { ArrowUp, Loader2, Plus, Trash2 } from 'lucide-react';
import { api } from '../../lib/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
export const URL_PRODUCTOS_MAPA = '/api/mapa-facial/productos';
const COLOR_NUEVO = '#2563eb';

export default function ProductosMapaDialog({ productos = [], onClose, onGuardados }) {
  const [filas, setFilas] = useState(() => productos.map((p) => ({ ...p })));
  const [guardando, setGuardando] = useState(false);

  const cambiar = (i, campo, valor) => setFilas((f) => f.map((p, j) => (j === i ? { ...p, [campo]: valor } : p)));
  const quitar = (i) => setFilas((f) => f.filter((_, j) => j !== i));
  const subir = (i) => setFilas((f) => {
    if (i === 0) return f;
    const copia = [...f];
    [copia[i - 1], copia[i]] = [copia[i], copia[i - 1]];
    return copia;
  });

  const guardar = async () => {
    setGuardando(true);
    try {
      await api.put(URL_PRODUCTOS_MAPA, {
        productos: filas.map(({ id, label, corto, color }) => ({ id: id || '', label, corto: corto || '', color })),
      });
      toast.success('Productos del mapa guardados');
      onGuardados?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'No se pudieron guardar los productos');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose?.(); }}>
      <DialogContent className="max-w-lg" data-testid="productos-mapa-dialog">
        <DialogHeader><DialogTitle>Productos del mapa facial</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">
          Lo que se marca en la cara, con su color. El primero es el que sale elegido al abrir el mapa.
        </p>
        <div className="space-y-2">
          {filas.length === 0 && <p className="text-sm text-muted-foreground">Ninguno todavía.</p>}
          {filas.map((p, i) => (
            <div key={p.id || `nuevo-${i}`} className="flex items-center gap-2">
              <input type="color" value={p.color} onChange={(e) => cambiar(i, 'color', e.target.value)}
                className="h-9 w-10 rounded border border-input p-0.5 shrink-0" aria-label="Color" />
              <Input value={p.label} maxLength={40} placeholder="Nombre" onChange={(e) => cambiar(i, 'label', e.target.value)}
                data-testid={`productos-mapa-nombre-${i}`} />
              <Input value={p.corto || ''} maxLength={8} placeholder="Abrev." className="w-24"
                onChange={(e) => cambiar(i, 'corto', e.target.value)} />
              <button type="button" onClick={() => subir(i)} disabled={i === 0} title="Subir"
                className="text-muted-foreground disabled:opacity-30"><ArrowUp className="w-4 h-4" /></button>
              <button type="button" onClick={() => quitar(i)} title="Quitar"
                className="text-muted-foreground hover:text-red-700"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
        <Button variant="outline" size="sm" className="self-start"
          onClick={() => setFilas((f) => [...f, { id: '', label: '', corto: '', color: COLOR_NUEVO }])}
          data-testid="productos-mapa-anadir">
          <Plus className="w-4 h-4 mr-1" /> Añadir producto
        </Button>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={guardar} disabled={guardando} className="bg-[#2E6E5E] hover:bg-[#1E4A3F]"
            data-testid="productos-mapa-guardar">
            {guardando && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Guardar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
